import React, { useState, useEffect } from "react";
import { Box, Tooltip } from "@mui/material";

const RoleBadge = ({ roles }) => {
  const [hoveredRole, setHoveredRole] = useState(null);

  if (!roles || roles.length === 0) {
    return <p>No roles assigned.</p>;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
      {roles.map((role, index) => {
        const roleColor = getRoleColor(index); // Get color based on index
        const isHovered = hoveredRole === index;

        const isSingleRole = roles.length === 1;

        return (
          <Box
            key={index}
            onMouseEnter={() => setHoveredRole(index)}
            onMouseLeave={() => setHoveredRole(null)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "32px",
              minWidth: isHovered || isSingleRole ? "60px" : "32px",
              maxWidth: isHovered || isSingleRole ? "150px" : "32px",
              borderRadius: isHovered || isSingleRole ? "20px" : "50%",
              backgroundColor: roleColor,
              color: "white",
              fontSize: "12px",
              fontWeight: "bold",
              cursor: "pointer",
              padding: isHovered || isSingleRole ? "0 14px" : "0",
              marginLeft: index === 0 ? "0px" : "-8px",
              transition: "all 0.3s ease-in-out",
              zIndex: isHovered || isSingleRole ? 10 : 1,
              border: "2px solid white",
              boxSizing: "border-box",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {(isHovered || isSingleRole) ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: roleColor,
                  color: "white",
                  fontWeight: "bold",
                  height: "28px",
                  borderRadius: "16px",
                  whiteSpace: "nowrap",
                  padding: "0 12px",
                  opacity: isHovered || isSingleRole ? 1 : 0,
                  transition: "opacity 0.2s ease-in-out",
                }}
              >
                {role.securityrole.name}
              </Box>
            ) : (
              <Tooltip 
                title={role.securityrole.name} 
                placement="top"
              >
                <span>{role.securityrole.name.charAt(0)}</span>
              </Tooltip>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

const getRoleColor = (index) => {
  const colors = ["#000000", "#1E90FF", "#FFD700", "#8A2BE2", "#E91E63", "#4CAF50"]; 
  return colors[index % colors.length]; 
};

export const RenderRoleBadges = ({ userRoles, systemRoles }) => {
  const [rolesData, setRolesData] = useState([]); // Store fetched roles
  const [loading, setLoading] = useState(true);

  // console.log(systemRoles)

  useEffect(() => {
    const fetchRoles = async () => {
      if (!userRoles) return;
      
      // Ensure userRoles is always an array
      const rolesArray = Array.isArray(userRoles) ? userRoles : [userRoles];

      const matchedRoles = rolesArray.flatMap(role =>
        systemRoles.filter(
          systemRole => systemRole.securityrole.roleid === role.roleid
        )
      );

      setRolesData(matchedRoles);
      setLoading(false);
    };

    fetchRoles();
}, [userRoles]); // Runs when userRoles changes

  if (loading) return <span>Loading...</span>; // Show loading while fetching

  return (
    <Box display="flex" gap={1} flexWrap="wrap">
      <RoleBadge roles={rolesData} />
    </Box>
  );
};

export default RoleBadge;
